// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1FixT","header":"styles_header__30vv6","accommodationWrapper":"styles_accommodationWrapper__nWogH","offerList":"styles_offerList__3x9VN"};